import { Company } from '../../../types/company/Company'

const accountMapEndpoints = {
  list: (companyId: Company['id']) => `/companies/${companyId}/accounting/accounts/map` as const
}

export default accountMapEndpoints
